import React from 'react';
import { Note, type NoteProps } from './NotePrimitives';

export const AlertNote = ({
  size,
  className,
  children,
}: React.PropsWithChildren<Pick<NoteProps, 'size' | 'className'>>) => (
  <Note variant="alert" size={size} className={className}>
    {children}
  </Note>
);
